document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.product__media-list, .product__media');
  const segments = document.querySelectorAll('.product-media-segment');

  if (!gallery || segments.length === 0) return;

  let activeIndex = 0;

  const setActiveSegment = (index) => {
    segments.forEach((segment, i) => {
      segment.classList.toggle('is-active', i === index);
    });
  };

  // Horizontal swipe slider, shared by mobile and desktop.
  gallery.addEventListener('scroll', () => {
    const width = gallery.offsetWidth;
    if (!width) return;
    const index = Math.round(gallery.scrollLeft / width);

    if (index !== activeIndex && segments[index]) {
      activeIndex = index;
      setActiveSegment(index);
    }
  });
});
